<template>
  <div id="main-view">
    <el-container style=" border: 1px solid #eee">
        <el-container>
            <div id="content-view">
                <div id="control-area">
                    <!-- <div id="back-btn">返回课文</div> -->
                    <div id="show-answer-btn" @click="showAnswerMethod">{{showAnswer?'隐藏答案' : '显示答案'}}</div>
                </div>
                <div id="answer_area">
                    <div v-for="item,index in answerCardSectionDataList" :key="index" style="width: 100%;
                                                                                            display: flex;
                                                                                            flex-direction: column;
                                                                                            align-items: center;">
                        
                        <ChoiseQuestionDrill :cardTitle="DRILL_TYPE[item.drillType].label" :show-answer-flag="showAnswer" :questionData="item.items" v-if="item.drillType==100"></ChoiseQuestionDrill>
                        <EssayQuestionDrill :cardTitle="DRILL_TYPE[item.drillType].label" :show-answer-flag="showAnswer" :questionData="item.items" v-if="item.drillType==300"></EssayQuestionDrill>
                        <GapFillingDrill :cardTitle="DRILL_TYPE[item.drillType].label" :show-answer-flag="showAnswer" :questionData="item.items" v-if="item.drillType==200"></GapFillingDrill>
                        <DialogueQuestion :cardTitle="DRILL_TYPE[item.drillType].label" :show-answer-flag="showAnswer" :questionData="item.items" v-if="item.drillType==400"></DialogueQuestion>
                        <PassageChoiseQuestionDrill :cardTitle="DRILL_TYPE[item.drillType].label" :show-answer-flag="showAnswer" :questionData="item.items" v-if="item.drillType==600"></PassageChoiseQuestionDrill>
                        <SequencingDrill :cardTitle="DRILL_TYPE[item.drillType].label" :show-answer-flag="showAnswer" :questionData="item.items" v-if="item.drillType==700"></SequencingDrill>
                        <ReadbackDrill :cardTitle="DRILL_TYPE[item.drillType].label" :show-answer-flag="showAnswer" :questionData="item.items" v-if="item.drillType==500"></ReadbackDrill>

                        
                    </div>
                    
                </div>
                
            </div>
        </el-container>
        <el-aside width="400px">
            <div id="answer_card" v-if="answerCardSectionDataList.length > 0">
                <div id="answer-item" v-for="item,index in answerCardSectionDataList" :key="index">
                    <div id="cate-title">
                        {{DRILL_TYPE[item.drillType].label}}
                    </div>
                    <div id="grid" class="question-number-grid">
                        <div class="question-number" @click="scrollTo(subItem.drillId)" v-for="subItem,subIndex in item.items" :key="subIndex"> {{(subIndex+1)}} </div>                        
                    </div>
                </div>
                
            </div>
        </el-aside>
    </el-container>
    
  </div>
</template>

<script>
import { mapState,mapActions } from "vuex";
import ChoiseQuestionDrill from '@/components/drill/ChoiseQuestionDrill.vue'
import EssayQuestionDrill from '@/components/drill/EssayQuestionDrill.vue'
import GapFillingDrill from '@/components/drill/GapFillingDrill.vue'
import DialogueQuestion from "@/components/drill/DialogueQuestion.vue";
import PassageChoiseQuestionDrill from "@/components/drill/PassageChoiseQuestionDrill.vue";
import SequencingDrill from "@/components/drill/SequencingDrill.vue";
import ReadbackDrill from "@/components/drill/ReadbackDrill.vue";




import DrillApi from '@/api/src/drill/api/DrillApi'
import { DRILL_TYPE } from "@/utils/constant.js";
import { SUB_DRILL_TYPE } from "@/utils/constant.js";

const drillApi = new DrillApi()

export default {
    components: {
        ChoiseQuestionDrill,
        EssayQuestionDrill,
        GapFillingDrill,
        DialogueQuestion,
        PassageChoiseQuestionDrill,
        SequencingDrill,
        ReadbackDrill
    },
    
    computed:{
        // ...mapState({
        //     currentData:(state)=>state.question.currentData
        // })
    },

    mounted () {
    //    this.currentSectionId = '8475997496982446080'
        this.currentSectionId = this.$route.params.id
        this.getSectionTestData()
    },

    data() {
        return {
            DRILL_TYPE: DRILL_TYPE,
            SUB_DRILL_TYPE: SUB_DRILL_TYPE,
            showAnswer:false,
            currentSectionId:null,
            answerCardSectionDataList:[]
        }
    },

    methods: {

        async getSectionTestData(){
            let sectionId = this.currentSectionId
            let isNewSession = false
            let resp = await drillApi.getSectionTest(sectionId,isNewSession)
            
            this.answerCardSectionDataList = this.answerCardSectionDataList.concat(resp.sectionList)
            console.log(this.answerCardSectionDataList)
        },

        showAnswerMethod(){
            this.showAnswer = !this.showAnswer;
            // console.log(this.$store.state.question.currentData)
            // console.log(this.currentData)

            
            //cxstudy://cxstudy/login?fid=2023&fidType=1&token=83c4a3b85f6f8d185812937c5b64099d
            // this.$store.dispatch('question/GetTextbookInfo');
            // this.$store.dispatch('question/GetTextbookDetail',"8093380284517515264");
            // this.$store.dispatch('question/GetSectionTest','8093380360476360704')
            // this.$store.dispatch('question/GetChoiceQuestionDrill','8356790184357863424')
        },
        scrollTo(drillId){
            
            this.$nextTick(() => {
                var dom = document.getElementById(drillId);
                dom.scrollIntoView()
            });
           
        }
    }
}
</script>

<style lang="less">
    #main-view {
        background-color: rgb(235, 235, 235);
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        text-align: left;
    }
    #content-view {
        margin-left: 60px;
        width: 100%;
        max-height: 95vh;
        overflow: auto;
        margin: 20px;
        background: white;
        padding-bottom: 30px;
        div{
            background: white;
        }
        
    }
    #answer_area {
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    #answer_card {
        margin: 20px;
        margin-right: 20px;
        margin-left: 10px;
        background: white;
        padding: 20px;
    }

    .question-number-grid{
        display: flex;
        flex-direction: row;
        margin-top: 10px;
        flex-wrap:wrap; 
        .question-number {
            width: 30px;
            height: 30px;
            border: 1px solid #409EFF;
            text-align: center;
            line-height: 30px;
            margin-right: 10px;
            margin-bottom: 10px;
            border-radius: 4px;
            color: #409EFF;
            box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
        }
    }
    #control-area{
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        justify-content: right;
        #back-btn {
            width: 100px;
            height: 30px;
            background-color: #409EFF;
            color: #fff;
            border-radius: 15px;
            text-align: center;
            line-height: 30px;
            margin: 20px;
            box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
            font-size: 14px;
        }

        #show-answer-btn {
            width: 100px;
            height: 30px;
            background-color: #409EFF;
            color: #fff;
            border-radius: 15px;
            text-align: center;
            line-height: 30px;
            margin: 20px;
            cursor: pointer;
            display: inline-block;
            vertical-align: middle;
            font-size: 14px;
            box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
        }
    }
</style>